<template>
  <div v-loading="!scormUrl" ref="scormcomponent" class="h-100p yxtbiz-kng-scorm-chapter-content pr over-hidden yxtbiz-kng-scorm-player">
    <template v-if="scormUrl">
      <template v-if="isMultipleChapters">
        <div v-if="!showShapter" class="component-icon-btn showchapter-btn" @click="showShapter = 1">
          <i class="icons-scorm-showchapter"></i>
        </div>

        <div ref="divchapterlist" class="h-100p chapter-content-list " :class="{ 'showchapter-list': showShapter }">
          <div class="chapter-list-title ellipsis" :title="title">
            {{ title }}
          </div>
          <div class="chapter-content-list-chapters">
            <yxt-tree class="mt16 lh-1 yxtbiz-kng-scorm-chapter-content height-68vh" :data="courseChapterContent" node-key="treeId"
              default-expand-all @current-change='chooseChapter' :current-node-key="currentChapter.treeId">
              <span slot-scope="{ data }" class="custom-tree-node">
                <div class="chaptername ellipsis" :title="data.chapterName">{{ data.chapterName }} </div>
              </span>
            </yxt-tree>
          </div>
          <div v-if="showShapter" class="component-icon-btn hidechapter-btn" @click="showShapter = 0">
            <i class="icons-scorm-hidechapter"></i>
          </div>
        </div>
      </template>

      <div ref="divchaptercontent" :class="{ 'chapter-content-showchapters': showShapter }"
        class="h-100p chapter-content">
        <iframe class="iframe over-hidden h-100p yxtbiz-kng-scorm-chapter-content" allowfullscreen="true" webkitallowfullscreen="true"
          mozallowfullscreen="true" :src="scormUrl">
        </iframe>
      </div>
    </template>
    <yxtbiz-watermark :option="watermarkConfig" app-code="kng" version="v2"></yxtbiz-watermark>
    
    <!-- 全屏 -->
    <div v-if="!isFullScreen" ref="divFullscreen" class="component-icon-btn fullscreen-btn" @mouseup="onFullscreenChange(1, $event)">
      <yxtf-svg :remote-url="stcSvg" icon-class="fscreen" class="v-mid svgicon"></yxtf-svg>
      <div class="fullscreen-tip">
        <span class="v-mid d-in-block ml8 mr8"> {{ $t('pc_kng_scorm_btn_fullscreen1'/* 全屏模式 */) }}</span>
      </div>
    </div>
    <!-- 退出全屏 -->
    <div v-if="isFullScreen" ref="divExitFullscreen" class="component-icon-btn fullscreen-btn" @mouseup="onFullscreenChange(0, $event)">
      <yxtf-svg :remote-url="stcSvg" icon-class="escreen" class="v-mid svgicon"></yxtf-svg>
      <div class="fullscreen-tip">
        <span class="v-mid d-in-block ml8 mr8"> {{ $t('pc_kng_scorm_btn_fullscreen_exit'/* 退出全屏 */) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrgpParameter, getScormChapters } from './service.js';
import { enmuFunctions } from '../../function-points';
import commonUtil from '../../common-util';
import qs from 'qs';

export default {
  name: 'YxtbizKngScormPlayer',
  name_zh: 'scorm播放器',
  eventList: [{
    type: 'change',
    handler: 'completed',
    label: '内容完成触发'
  }],
  props: {
    title: {
      type: String,
      require: true,
      desc: '课件标题',
      setter: 'StringSetter'
    },
    playInfo: {
      type: Object,
      require: true,
      desc: '课件播放详情',
      setter: 'JsonSetter'
    },
    query: {
      type: Object,
      require: true,
      desc: '包含kngId必传，courseId、targetCode、targetId等可选',
      setter: 'JsonSetter'
    },
    preview: {
      type: Number,
      default: 0,
      desc: '是否预览查看 0：否，1：预览',
      setter: 'NumberSetter'
    },
    watermarkConfig: {
      type: Object,
      desc: '水印信息',
      setter: 'JsonSetter'
    }
  },
  computed: {
    stcSvg() {
      return `${window.feConfig.common.staticBaseUrl}ufd/407a24/kng/pc/svg`;
    }
  },
  data() {
    return {
      isFullScreen: 0, // 是否全屏播放
      envFlag: 1, // 0，私有云课件
      scopreviewUrl: '', // scorm章节前缀
      scormUrl: '', // scorm播放地址
      courseChapterContent: [], // 章节
      scormPlayFilePath: '', // scorm播放器地址
      scormDomainReplace: 0, // 要素控制scorm播放地址替换域名，统一域名
      isMultipleChapters: 0, // 是否多章节
      showShapter: 0,
      currentChapter: null, // 当前章节
      chaptersCount: 0
    };
  },
  async created() {
    this.scormDomainReplace = commonUtil.checkTimeOutFnc(enmuFunctions.SCORM_DOMAIN_REPLACE) === 2;
  },
  mounted() {
    // 课件iframe
    // scorm课件，需要和 scowrapperstudy.html（中间页）通信
    window.addEventListener('message', this.scormMessage);
    window.addEventListener('resize', this.onScormResize);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('message', this.scormMessage);
      window.removeEventListener('resize', this.onScormResize);
    });
  },
  methods: {
    // 关于scorm中间件的存储位置，私有化的读取机构参
    async getPrivateScormPlayFilePath() {
      if (!window.feConfig.orgCode) return;
      try {
        const res = await getOrgpParameter('ScormPlayFilePath', localStorage.orgId);
        if (res.value) {
          this.scormPlayFilePath = `${res.value}scorm/scowrapperstudy.html`;
        }
      } catch (error) { }
    },
    // scorm 内容完成
    scormMessage(message) {
      const msgData = message.data;
      if (msgData && msgData.type === 'scormMessage' && msgData.completed) {
        // 接收到中间页的消息，抛出事件scorm内容完成
        this.$emit('completed');
      }
    },

    // 首次播放时，设置相关参数
    async playStudy() {
      await this.getPrivateScormPlayFilePath(); // 关于scorm中间件的存储位置，私有化的读取机构参
      this.courseVersion = this.playInfo.courseVersion; // 是否是标准scorm 0代表不是，其他代表是
      if (this.playInfo.playDetails && this.playInfo.playDetails.length) {
        this.scopreviewUrl = this.playInfo.playDetails[0].url;
        this.envFlag = this.playInfo.envFlag;
        this.initChapters();
      }
    },
    // 初始化章节列表
    initChapters() {
      getScormChapters(this.query.kngId).then(res => {
        // 数据各种各样，必须做容错处理
        try {
          if (res.length !== 0) {
            this.courseChapterContent = this.dealTreeNode(res, '');
            this.isMultipleChapters = this.chaptersCount > 1;
            this.showShapter = this.chaptersCount > 1;
            this.setChpter(this.currentChapter);
          } else {
            this.setChpter({chapterHref: 'index.html', id: this.createUuid()});
          }
        } catch (error) {
          this.setChpter({chapterHref: 'index.html', id: this.createUuid()});
        }
      });
    },
    // 递归处理树节点
    dealTreeNode(data, id) {
      if (!data || !data.map) return;
      return data.map(item => {
        this.chaptersCount++;
        item.label = item.chapterName;
        item.parentId = id;
        item.treeId = item.id;
        // 后端多层级不会返回id，提交数据用第一层id，树结构用自建id
        if (!item.id) {
          item.treeId = this.createUuid();
          item.id = id;
        }
        if (!this.currentChapter && item.chapterHref) {
          this.currentChapter = item;
        }
        if (item.childChapters) {
          item.children = this.dealTreeNode(item.childChapters, item.id);
        }
        return item;
      });
    },
    // esc 退出全屏改变全屏按钮状态
    onScormResize() {
      this.isFullScreen = !!(document.mozFullscreen || document.fullscreen || document.webkitIsFullScreen);
    },
    // 全屏/退出全屏
    onFullscreenChange(fullscreen, e) {
      if (e.currentTarget.isdragging) {
        return;
      }

      let element = this.$refs.scormcomponent;
      if (fullscreen) {
        const func = element.requestFullscreen ||
          element.mozRequestFullScreen ||
          element.webkitRequestFullscreen ||
          element.msRequestFullscreen;
        func.call(element);
      } else {
        const func = document.exitFullScreen ||
          document.mozCancelFullScreen ||
          document.webkitExitFullscreen ||
          document.msExitFullscreen;
        func.call(document);
      }
      setTimeout(() => this.onScormResize(), 500);
    },
    // 选择章节
    chooseChapter(chapter) {
      if (chapter.chapterHref) {
        this.setChpter(chapter);
      }
    },
    // 设置播放章节地址
    setChpter(chapter) {
      this.currentChapter = chapter;
      this.scormUrl = this.getScormUrl(chapter.chapterHref, chapter.id);
    },
    // 获取播放地址
    getScormUrl(chapterHref, chapterId) {
      if (this.scormPlayFilePath === '') {
        this.scormPlayFilePath = this.getScormPlayFilePath(this.envFlag, this.scopreviewUrl);
      }

      // 要素控制scorm播放地址替换域名
      if (this.scormDomainReplace) {
        // scorm统一域名，仅此一家客户【ata.yunxuetang.cn】替换链接
        const streamobsScorm = document.domain + '/streamobs-scorm';
        this.scormPlayFilePath = this.scormPlayFilePath.replace('streamobs.yunxuetang.cn', streamobsScorm);
        this.scopreviewUrl = this.scopreviewUrl.replace('streamobs.yunxuetang.cn', streamobsScorm);
      }

      const param = {
        ...this.query,
        token: localStorage.token || '',
        scoId: chapterId,
        userId: localStorage.username,
        username: localStorage.fullname,
        source: 501,
        preview: this.preview,
        version: this.courseVersion,
        apiDomain: window.feConfig.common.kng || '',
        domain: window.location.origin,
        playerVersion: '4.2.2'
      };
      return `${this.scormPlayFilePath}?sco=${this.scopreviewUrl}${chapterHref}&${qs.stringify(param)}`;
    },
    // 获取SaaS中间件地址
    getScormPlayFilePath(envFlag, scoUrl) {
      // envFlag === 0，私有云课件
      const matched = scoUrl.match(/^(?:(http[s]?):)?\/\/.*?\//i);
      const host = (matched ? matched[0] : '');
      if (envFlag) {
        return host + `media/scorm/${window.feConfig.apiEnv}/scowrapperstudy.html`;
      } else {
        return host + 'scorm/scowrapperstudy.html';
      }
    },
    createUuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  watch: {
    query: {
      handler(val) {
        if (val.kngId) {
          this.playStudy();
        }
      },
      immediate: true
    }
  }
};
</script>


<style lang="scss" scoped>
.h-100p {
  height: 100%;
}

.yxtbiz-kng-scorm-chapter-content {
  width: 100% !important;
}

.iframe {
  border: none;
}

.showchapter-list {
  display: block !important;
}

.chapter-content-list {
  left: 0;
  position: absolute;
  height: 100%;
  width: 290px;
  background: #f2f4f7;
  display: none;
  padding: 16px;
  box-sizing: border-box;
}

.component-icon-btn {
  position: relative;
  display: inline-block;
  border-radius: 2px;
  white-space: nowrap;
  flex-shrink: 0;
  z-index: 1;
}

.showchapter-btn {
  position: absolute;
  top: 25px;
  padding: 8px 8px 8px 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-left: none;
  border-radius: 0 58px 58px 0;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}

.icons-scorm-showchapter {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  flex-shrink: 0;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxMWg1djJIM3YtMnptMC00aDEwdjJIM1Y3em0xMC00djJIM1YzaDEweiIgZmlsbD0iI0FFQjVDMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+);
}

.icons-scorm-hidechapter {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  flex-shrink: 0;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC45IDguMTkybDQuMjQyIDQuMjQzLS43MDcuNzA3TDguMTkyIDguOSAzLjk1IDEzLjE0MmwtLjcwNy0uNzA3IDQuMjQyLTQuMjQzTDMuMjQzIDMuOTVsLjcwNy0uNzA3IDQuMjQyIDQuMjQyIDQuMjQzLTQuMjQyLjcwNy43MDdMOC45IDguMTkyeiIgZmlsbD0iIzZBNkE2QSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+);
}

.hidechapter-btn {
  cursor: pointer;
  width: 12px;
  height: 12px;
  position: absolute;
  right: 16px;
  z-index: 9999;
  top: 16px;
}

.chapter-content {
  position: relative;
  width: 100%;
}

.chapter-content-showchapters {
  margin-left: 290px;
  width: calc(100% - 290px) !important;
}

.chapter-list-title {
  width: 240px;
  color: #595959;
}

.chaptername {
  width: 230px;
}

.chapter-content-list-chapters {
  margin-top: 10px;
}

.fullscreen-btn {
  display: block;
  position: absolute;
  bottom: 130px;
  right: -19px;
  height: 36px;
  line-height: 36px;
  padding: 0 11px;
  border: none;
  border-radius: 4px 0 0 4px;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  user-select: none;
  transition: all .3s ease;
}
.fullscreen-btn .fullscreen-tip{
  transition: 0s;
  transition-delay:0s;
  opacity: 0;
  // display: none;
}
.fullscreen-btn:hover {
  color: white;
  transform: translateX(-19px);
}
.fullscreen-btn:hover .fullscreen-tip{
  // display: block;
  transition: opacity .2s ease;
  transition-delay:0.3s;
  opacity: 1;
}




.svgicon {
  width: 14px;
  height: 14px;
}

::v-deep .yxt-scrollbar__bar.is-horizontal {
  display: none;
}

::v-deep .yxt-tree {
  background: #f2f4f7;
}
.fullscreen-tip{
  background: white;
  position: absolute !important;
  opacity: 0;
  line-height: 28px;
  color: black;
  top: -34px;
  z-index: 9999;
  right: 0px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px 0 0 4px;
}

</style>

